import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import EnodeInitHeader from '../components/ENodeInitHeader'

interface Props {
	onClose: () => any
}

const SmartChargeInfoDone: React.FC<Props> = ({ onClose }) => {
	const { t } = useTranslation('pages_enodeInit')

	return (
		<>
			<div className='flex flex-row gap-4'>
				<EnodeInitHeader position={5} total={5} text={t('smartChargeInfoDone.otsikko')} />
				<div className='h-[38px] flex items-center mb-2'>
					<span className='text-xl tracking-wide font-semibold dark:text-brand-secondary-100-dark'>
						{t('smartChargeInfoDone.otsikko')}
					</span>
				</div>
			</div>

			<div className='dark:text-white flex flex-col gap-4 mt-4 text-center'>
				<p>{t('smartChargeInfoDone.info')}</p>
			</div>

			<Button onClick={onClose}>{t('valmis', { ns: 'common' })}</Button>
		</>
	)
}

export default SmartChargeInfoDone
